/** EN uses Swedish values until translated. */
export const siteCoreEn = {
    title: 'Finance Lab App',
    nav: {
        menuSection: 'Menu',
        overview: 'Overview',
        issues: 'Issues',
        warrants: 'Warrants',
        convertibles: 'Convertibles',
        companies: 'Companies',
        advisors: 'Advisor',
        statistics: 'Statistics',
        news: 'News',
        calendar: 'Calendar',
        reports: 'Reports',
        settingsSection: 'Settings',
        support: 'Support',
        contact: 'Contact us',
        help: 'Help',
        feedback: 'Feedback',
        adminSection: 'Admin',
        adminDashboard: 'Dashboard',
        adminCustomers: 'Customers',
        adminUsers: 'Users',
        adminPRInput: 'PM Indata',
        adminPMCompany: 'PM Companies',
        adminDelistings: 'Delistings',
        adminIssues: 'Issues',
        adminIssuesReview: 'Cross-checking',
        adminIssuesNew: 'New Issue',
        adminCompanies: 'Company',
        adminCompaniesNew: 'New Company',
        adminWarrants: 'Warrants',
        adminWarrantsNew: 'New Warrant',
        adminConvertibles: 'Convertibles',
        adminConvertiblesNew: 'New Convertible',
        adminInvestors: 'Investors',
        adminKeywordFilter: 'Keyword Filter',
        language: 'Language',
        watchList: 'Watchlist',
        notes: 'Notes',
        searchPlaceholder: 'Search companies, issues, warrants, investors...',
    },
    auth: {
        loginPrompt: 'Sign in to continue',
        login: 'Sign in',
        logout: 'Sign out',
        changePassword: 'Change password',
        email: 'Email address',
        password: 'Password',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot password?',
    },
    convertibles: {
        previous: 'Ongoing',
        current: 'Ongoing',
        future: 'Upcoming',
        detailsTitle: 'Convertible {{name}}',
    },
    instruments: {
        bankruptcy: 'Bankruptcy',
        liquidation: 'Liquidation',
        merger: 'Merger',
        acquisition: 'Acquired',
        changed_marketplace: 'Change of marketplace',
        voluntary_delisting: 'Voluntary delisting',
        lack_of_compliance: 'Failure to meet listing requirements',
        redemption: 'Redemption',
    },
    issues: {
        previous: 'Completed',
        current: 'Ongoing',
        future: 'Upcoming',
        detailsTitle: 'Issue {{name}}',
    },
    warrants: {
        detailsTitle: 'Warrant {{name}}',
    },
    companies: {
        detailsTitle: 'Company: {{name}}',
    },
    advisors: {
        detailsTitle: 'Advisor: {{name}}',
    },
    statistics: {
        title: 'Statistics',
    },
}
